<template>
    <div class="participation list-box">
        <div v-if="pageState === 'list'">
            <Tree @changeSwitch="changeSwitch" :switchVal="isDown" @nodeClick="nodeClick"></Tree>
        </div>
        <div class="right-box" v-if="pageState === 'list'">
            <TableSearch :search-config="searchConfig" :search-params="searchParams"  @resetCallBack="reset()"  @search="search"></TableSearch>
            <Table :tabelButtons="tabelButtons" :table-config="tableConfig" :pagination="pagination" :template-data="tableData"></Table>
        </div>
        <!-- <el-dialog
                class="info-box"
                title="报警详情"
                :visible.sync="dialogVisible"
                width="40%">
            <AlarmDetailBox :alarm-detail-data="alarmInfo"></AlarmDetailBox>
        </el-dialog> -->
		<alarm-detail-im v-if="pageState === 'detail'" :alarm-id="alarmId" @back="backList"></alarm-detail-im>
    </div>
</template>

<script>
    import Tree from '@/components/Tree/nodeTree';
    import {listAPI} from '@/api-path/command-center.js'
	import AlarmDetailIm from '../alarm-detail-im/alarm-detail-im';
    export default {
        name: "participation",
        components: {
            Tree,
			AlarmDetailIm
        },
        data () {
            return {
				pageState:'list',
                dialogVisible: false,
                isDown: false, // 是否查询下级
				alarmId:'',
                searchConfig: {
                    dataName: 'searchParams',
                    items: [
                        {
                            placeholder: '输入姓名搜索',
                            key: 'search',
                        }, {
                            placeholder: '开始时间:结束时间',
                            valueType: 'datetimerange',
                            key: 'date'
                        }
                    ]
                },
                searchParams: {
                    areaId: '', // 区域ID
                    userId: sessionStorage.getItem('userId'), // 用户Id
                    date: [],
                    page: 1,
                    size: 15,
					search:''
                },
				tabelButtons:[],
                tableConfig: {
                    rows: [
                        {
                            label: '报警时间',
                            width: '130px',
                            prop: 'happenDate',
                        }, {
                            label: '报警人',
                            width: '70px',
                            prop: 'userName',
                        }, {
                            label: '处理人',
                            width: '70px',
                            prop: 'dealName',
                        }, {
                            label: '区域',
                            prop: 'areaName',
                        }, {
                            label: '接警中心',
                            prop: 'centerName',
                        }, {
                            label: '接警来源',
                            width: '80px',
                            prop: 'sourceName',
                        }, {
                            label: '报警类型',
                            prop: 'alarmType',
                        }, {
                            label: '报警内容',
                            prop: 'content',
                        }, {
                            label: '地点',
                            prop: 'address',
							width:'200px',
							type:"popover",
                        }, {
                            label: '状态',
                            prop: 'statusName',
                        }
                    ],
                    rowButtons: {
                        width: '180px',
                        items: [
                            {
                                show: `userId !== ${sessionStorage.getItem('userId')} ? show: false`,
                                label: '查看',
                                fn:(data)=>{
									this.$store.commit('setVisionGroupId',data.id);
									this.alarmId=data.id;
									this.pageState = 'detail';
								}
                            }, {
                                show: `userId === ${sessionStorage.getItem('userId')} ? show: false`,
                                label: '处理'
                            },
                        ]
                    },
                },
                tableData: [],
                pagination: {
                    show: true,
                    page: 1,
                    size: 15,
                    total: 0,
                    sizeChange: (size) => {
                        this.pagination.size = size
                        this.searchParams.size = size
                        this.search()
                    },
                    pageChange: (page) => {
                        this.pagination.page = page
                        this.searchParams.page = page
                        this.search()
                    },
                },
                alarmInfo: {},
            }
        },
        computed:{
        	newAlarm(){
        		return this.$store.state.hasNewAlarm//新的报警
        	},
			visionGroupId(){
				return this.$store.state.visionGroupId
			}
        },
        watch:{
        	newAlarm(newVal,oldVal){
        		if(newVal){
        			this.search();
        		}
        	},
			visionGroupId(newVal,oldVal){
				if(newVal){
					this.alarmId=newVal
					this.pageState='detail'
				}
			}
        },
		mounted() {
			if(this.$store.state.visionGroupId){
				this.alarmId=this.$store.state.visionGroupId
				this.pageState='detail'
			}
		},
		beforeDestroy() {
			this.$store.commit('setVisionGroupId','');
		},
        methods: {
			
			backList() {
				this.pageState = 'list'
			},
            search() {
                const {date, ...params} = {...this.searchParams}
                params.startTime = date[0]
                params.endTime = date[1]
                params.isDown = this.isDown
                this.$http.get(listAPI.participation, {params}).then(res => {
                    if(res.status === 200) {
                        res.result.pageList.map(item => {
                            item.alarmSource = this.matchFn.matchCodeName('ALARM_SOURCE', item.alarmSource)
                            item.alarmType = this.matchFn.matchCodeName('ALARM_TYPE', item.alarmType)
                        })
                        this.tableData = res.result.pageList
                        this.pagination.total = res.result.total
						this.$store.commit('setHasNewAlarm',false)
                    }
                })
            },
            getAlarmDetail(data) {
                this.$http.get(listAPI.datail + '?alarmId=' + data.id).then(res => {
                    this.dialogVisible = true
                    res.result.handlers.map(item => {
                        item.isOpen = false
                    })
                    this.alarmInfo = res.result
                })
            },

            changeSwitch(node) {
                this.isDown = node
                this.search()
            },
            nodeClick(node) {
                this.searchParams.areaId = node.id;
				this.searchParams.page=this.pagination.page=1;
				this.areaId=node.id;
                this.search()
            },
			reset(){
				this.searchParams.page=this.pagination.page=1;
				this.searchParams.size=this.pagination.size=15;
				this.searchParams.areaId=this.areaId;
				this.searchParams.userId=sessionStorage.getItem('userId');
				this.searchParams.date=[];
				this.searchParams.search='';
				this.search();
			}
        }
    }
</script>

<style scoped lang="less">
@import "participation";
</style>
